import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold tracking-wide transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed uppercase';
  const variants = {
    primary: 'bg-brand-accent text-brand-dark hover:bg-brand-accentHover hover:scale-105',
    secondary: 'bg-white text-brand-dark hover:bg-gray-200 hover:scale-105',
    outline: 'border-2 border-brand-accent text-brand-accent hover:bg-brand-accent hover:text-brand-dark'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-194">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-195" />}
    </button>;
}